import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CustomerService } from '../../../core/services/customer.service';
import { FilesService } from '../../../core/services/files.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzUploadXHRArgs } from 'ng-zorro-antd/upload';

const CUSTOMER_ADD_POPUP_FILE_UPLOAD = 'CUSTOMER_ADD_POPUP_FILE_UPLOAD';

@Component({
  selector: 'app-add-customer-popup',
  templateUrl: './add-customer-popup.component.html',
  styleUrls: ['./add-customer-popup.component.scss'],
})
export class AddCustomerPopupComponent implements OnInit {
  @Output() addEditCustomerOnChange: EventEmitter<any> = new EventEmitter();
  @Input() isVisible: boolean = false;
  customerForm: FormGroup | any;
  formErrors: any;
  passportLicenceFiles: any[] = [];
  countryData: any;
  filteredCountryData: any;
  filteredCountryDailCodeData: any;
  filteredBirthCountryData: any;
  passportLicenceUploading = false;
  passExists = false;
  pastDateDisabled = (current: Date): boolean => {
    const today = new Date();
    const yesterday = new Date(
      today.getFullYear(),
      today.getMonth(),
      today.getDate() - 1,
    );
    return current <= yesterday;
  };

  constructor(
    private customerService: CustomerService,
    private filesService: FilesService,
    private message: NzMessageService,
    private fb: FormBuilder,
  ) {}

  ngOnInit(): void {
    this.uploadLoader();
    this.customerService.fetchJsonData().subscribe((data) => {
      this.countryData = data;
      this.filteredCountryData = this.countryData;
      this.filteredCountryDailCodeData = this.countryData;
      this.filteredBirthCountryData = this.countryData;
    });
    this.initCustomerForm();
    this.initFormErrors();
    this.passportLicenceFiles = [];
  }

  initCustomerForm(): void {
    this.customerForm = this.fb.group({
      renterDetails: this.fb.group({
        fullName: [
          null,
          [
            Validators.required,
            Validators.maxLength(70),
            Validators.pattern(/^[a-zA-Z\s]*$/),
          ],
        ],
        title: [null, [Validators.required]],
        email: [null, [Validators.maxLength(100), Validators.email]],
        contactNo: [
          null,
          [
            Validators.required,
            Validators.maxLength(15),
            Validators.pattern(/^\d+$/),
          ],
        ],
        dailCode: [null, [Validators.required]],
        homeAddress: [null],
        homeCountry: [null, Validators.required],
        otherCountry: [null],
        dob: [null],
        birthCity: [null],
        birthCountry: [null],
      }),
      passportLicenceDetails: this.fb.group({
        passportNo: [null],
        issueDatePass: [null],
        expiryDatePass: [null],
        drivingLicenceNo: [null],
        issueDateLicence: [null],
        expiryDateLicence: [null],
      }),
    });
  }

  initFormErrors() {
    this.formErrors = {
      renterDetails: this.fb.group({
        fullName: {},
        contactNo: {},
        homeAddress: {},
        homeCountry: {},
        otherCountry: {},
        dob: {},
        birthCity: {},
        birthCountry: {},
      }),
      passportLicenceDetails: this.fb.group({
        passportNo: {},
        issueDatePass: {},
        expiryDatePass: {},
        drivingLicenceNo: {},
        issueDateLicence: {},
        expiryDateLicence: {},
      }),
    };
  }

  uploadLoader() {
    this.filesService.fileUploadingSubject.subscribe((res: any) => {
      switch (res.type) {
        case CUSTOMER_ADD_POPUP_FILE_UPLOAD:
          this.passportLicenceUploading = res.loading;
          break;
      }
    });
  }

  upload = (item: NzUploadXHRArgs) =>
    this.filesService
      .postFile(item.file, CUSTOMER_ADD_POPUP_FILE_UPLOAD)
      .subscribe((res) => {
        this.message.create('success', `Attachment has been uploaded!`);
        const data = res as any;
        this.passportLicenceFiles.push({ name: data.name, url: data.url });
        this.filesService.fileUploadingSubject.next({
          type: CUSTOMER_ADD_POPUP_FILE_UPLOAD,
          loading: false,
        });
      });

  confirmRemoveAttachment(attachmentId: any): void {
    this.message.create('success', `Attachment has been deleted!`);
    this.passportLicenceFiles.splice(attachmentId, 1);
  }

  cancel(): void {}

  confirm(): void {
    this.isVisible = false;
    this.addEditCustomerOnChange.emit({ name: 'isVisible', value: false });
  }

  onSubmit(): void {
    const emailControl = this.customerForm.get('renterDetails.email');

    // Check if the email is empty
    if (!emailControl.value) {
      this.submitForm();
    } else {
      this.customerService
        .getCustomerByEmail({
          email: emailControl.value,
        })
        .subscribe(
          (res: any) => {
            if (res) {
              this.message.create('warning', `Email is already existing!`);
            } else {
              this.submitForm();
            }
          },
          (e: any) => {
            this.message.create('error', 'Error');
          },
        );
    }
  }

  // Extracted method to handle form submission
  private submitForm(): void {
    this.customerService
      .createCustomer({
        ...this.customerForm.value,
        passportLicenceFiles: this.passportLicenceFiles,
      })
      .subscribe(
        () => {
          this.customerForm.reset();
          this.passportLicenceFiles = [];
          this.isVisible = false;
          this.addEditCustomerOnChange.emit({
            name: 'created',
            value: false,
          });
        },
        (e: any) => {
          this.message.create('error', 'Error');
        },
      );
  }

  // onSubmit(): void {
  //   this.customerService
  //     .getCustomerByEmail({
  //       email: this.customerForm.get('renterDetails.email').value,
  //     })
  //     .subscribe(
  //       (res: any ) => {
  //         if (res) {
  //           this.message.create('warning', `Email is already existing!`);
  //         } else {
  //           this.customerService
  //             .createCustomer({
  //               ...this.customerForm.value,
  //               passportLicenceFiles: this.passportLicenceFiles,
  //             })
  //             .subscribe(
  //               () => {
  //                 this.customerForm.reset();
  //                 this.passportLicenceFiles = [];
  //                 this.isVisible = false;
  //                 this.addEditCustomerOnChange.emit({
  //                   name: 'created',
  //                   value: false,
  //                 });
  //               },
  //               (e: any) => {
  //                 this.message.create('error', 'Error');
  //               },
  //             );
  //         }
  //       },
  //       (e: any) => {
  //         this.message.create('error', 'Error');
  //       },
  //     );
  // }

  //   onSubmit(): void {
  //     const email = this.customerForm.get('renterDetails.email').value;
  //
  //     // Check if the email is empty
  //     if (!email) {
  //       // If the email is empty, create the customer directly
  //       this.createCustomer();
  //       return;
  //     }
  //
  //     // If the email is not empty, proceed with the email check
  //     this.customerService.getCustomerByEmail({ email }).subscribe(
  //       (res: any) => {
  //         if (res) {
  //           this.message.create('warning', `Email is already existing!`);
  //         } else {
  //           this.createCustomer();
  //         }
  //       },
  //       (e: any) => {
  //         this.message.create('error', 'Error');
  //       },
  //     );
  //   }
  //
  // // Separate method to create the customer
  //   createCustomer(): void {
  //     this.customerService.createCustomer({
  //       ...this.customerForm.value,
  //       passportLicenceFiles: this.passportLicenceFiles,
  //     }).subscribe(
  //       () => {
  //         this.customerForm.reset();
  //         this.passportLicenceFiles = [];
  //         this.isVisible = false;
  //         this.addEditCustomerOnChange.emit({
  //           name: 'created',
  //           value: false,
  //         });
  //       },
  //       (e: any) => {
  //         this.message.create('error', 'Error');
  //       },
  //     );
  //   }
  //
  //
  //
  //

  checkExisting(event: any): void {
    console.log(event);
    this.customerService
      .getCustomerByFilter({
        filter: this.customerForm.get('passportLicenceDetails.passportNo')
          .value,
      })
      .subscribe((res) => {
        if (res && Object.keys(res).length > 0) {
          // Passport number exists
          this.passExists = true;
          this.customerForm
            .get('passportLicenceDetails.passportNo')
            .setErrors({ exists: true });
        } else {
          // Passport number does not exist
          this.passExists = false;
          this.customerForm
            .get('passportLicenceDetails.passportNo')
            .setErrors(null);
        }
      });
  }

  onCancelConfirm(): void {
    this.customerForm.reset();
    this.isVisible = false;
    this.addEditCustomerOnChange.emit({
      name: 'isVisible',
      value: false,
    });
  }

  handleCancel(): void {
    this.customerForm.reset();
    this.isVisible = false;
    this.addEditCustomerOnChange.emit({
      name: 'isVisible',
      value: false,
    });
  }

  onSearchDailCode(searchValue: string): void {
    if (searchValue) {
      // Filter the country data based on the search value
      this.filteredCountryDailCodeData = this.countryData.filter(
        (country: { dial_code: string }) =>
          country.dial_code.toLowerCase().includes(searchValue.toLowerCase()),
      );
    } else {
      // If the search value is empty, show all countries
      this.filteredCountryDailCodeData = this.countryData;
    }
  }
  onSearchHomeCountry(searchValue: string): void {
    if (searchValue) {
      // Filter the country data based on the search value
      this.filteredCountryData = this.countryData.filter(
        (country: { name: string }) =>
          country.name.toLowerCase().includes(searchValue.toLowerCase()),
      );
    } else {
      // If the search value is empty, show all countries
      this.filteredCountryData = this.countryData;
    }
  }

  onSearchBirthCountry(searchValue: string): void {
    if (searchValue) {
      // Filter the country data based on the search value
      this.filteredBirthCountryData = this.countryData.filter(
        (country: { name: string }) =>
          country.name.toLowerCase().includes(searchValue.toLowerCase()),
      );
    } else {
      // If the search value is empty, show all countries
      this.filteredBirthCountryData = this.countryData;
    }
  }

  handleOk(): void {}
}
